import { h, Fragment } from "preact";
import { Typography, Box, TableRow, TableCell, Tooltip, IconButton } from "@mui/material";
import CircularProgressWithLabel from "../Common/CircularProgressWithLabel";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import palette from "../../theme/palette";


export default function BackButton({ tooltip, from }) {
    const nb_u = 0;
    return (
        <Tooltip title="Revenir au dossier de vente">
            <IconButton color="primary" onClick={() => {
                //	window.location.href = from; //"/1fdf58e512f54752959b369588380557/" + uid;
                if (from !== undefined) {
                    window.location.replace(from)
                } else {
                    window.location.replace("/dashboard")
                }

            }}>

                <ArrowBackIosNewIcon color="primary" style={`background-color: ${palette.primary.main}; color: white; box-sizing: content-box; padding: 8px 16px; border-radius: 4px;`} />

            </IconButton>
        </Tooltip>
    );
}
